module.exports = "<mat-progress-bar mode=\"indeterminate\" *ngIf=\"isLoading\"></mat-progress-bar>\n<div class=\"box\" *ngIf=\"isLoading\"></div>\n"